import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { setMultiPostError } from 'services/compose'
import { PINTEREST_MULTI_ACCOUNT_ERROR_CODE } from 'services/compose/multi'
import { BulkContentPost } from 'services/compose/state'
import { BRAND_PINTEREST } from 'shared/constants'
import { StoreThunkDispatch } from 'store/state'

/** Pinterest cannot receive the same content on multiple accounts — flags/clears the error as the profile count changes. */
export function usePinterestMultiAccountError(post: BulkContentPost, profilesCount: number) {
  const dispatch = useDispatch<StoreThunkDispatch>()
  const { network, error, id } = post

  useEffect(() => {
    if (network !== BRAND_PINTEREST) {
      return
    }

    if (profilesCount > 1 && !error) {
      dispatch(setMultiPostError({
        postId: id,
        error: {
          code: PINTEREST_MULTI_ACCOUNT_ERROR_CODE,
          message: 'Pinterest does not allow Post Planner to post the same content to multiple Pinterest accounts.'
        }
      }))
    }

    if (profilesCount === 1 && error?.code === PINTEREST_MULTI_ACCOUNT_ERROR_CODE) {
      dispatch(setMultiPostError({ postId: id, error: undefined }))
    }
  }, [network, profilesCount, id, dispatch, error])
}
